import type { AccountRef, UserProfile } from '../types/profile'

/**
 * Comptes réellement **sélectionnables** par l'utilisateur — issue #47.
 *
 * `profile.accounts` n'est pas le périmètre effectif : pour un `Reseller`, le backend construit
 * `accountIds = [user.AccountId, ...scopeClients]` (`getUserProfile.ts`), donc le **compte revendeur
 * lui-même arrive en tête**. Or `getResellerScope` l'en **retire explicitement**, et
 * `assertTenantAccess` refuse tout `AccountId` hors de ce périmètre : l'IHM proposait — et
 * sélectionnait par défaut — une entrée que l'autorisation refuse par construction, d'où un
 * `403 ACCOUNT_ACCESS_DENIED` sur toutes les pages de données.
 *
 * Cette fonction est le **miroir frontend de `getResellerScope`** : elle n'élargit rien (élargir le
 * périmètre serait une régression sur l'invariant 3 du registre — *Scoping Revendeur*), elle aligne
 * seulement ce que l'IHM offre sur ce que l'autorisation accepte.
 *
 * Elle doit **bouger avec `getResellerScope`** : le jour où un revendeur devient une cible d'audit
 * légitime (issue #48, qui amende l'invariant 3), son compte rentrera dans le périmètre backend et
 * cette exclusion devra être levée en même temps.
 */
export function selectableAccounts(profile: UserProfile | null): AccountRef[] {
  if (!profile) return []
  if (profile.role !== 'Reseller') return profile.accounts
  return profile.accounts.filter(a => a.accountId !== profile.userAccountId)
}
